// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"73cce676","732":"a7ea7784","977":"910fc899"}[chunkId] + ".chunk.js";
};